import React, { useState } from "react";
import { LogOut, UserCircle2, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth, activeWorkgroupId, formatError } from "@/lib/auth";
import { api } from "@/lib/api";

function PasswordDialog({ open, setOpen }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [msg, setMsg] = useState(null);
  const save = async () => {
    try {
      await api.changePassword(current, next);
      setMsg({ ok: true, text: "Password changed." });
      setCurrent("");
      setNext("");
    } catch (e) {
      setMsg({ ok: false, text: formatError(e) });
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setMsg(null); }}>
      <DialogContent className="sm:max-w-sm" data-testid="password-dialog">
        <DialogHeader><DialogTitle>Change password</DialogTitle></DialogHeader>
        <Input type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="password-current-input" />
        <Input type="password" placeholder="New password (8+ characters)" value={next} onChange={(e) => setNext(e.target.value)} data-testid="password-new-input" />
        {msg && <p className={`text-sm ${msg.ok ? "text-emerald-300" : "text-rose-300"}`} data-testid="password-msg">{msg.text}</p>}
        <Button onClick={save} disabled={!current || next.length < 8} data-testid="password-save-btn">Save</Button>
      </DialogContent>
    </Dialog>
  );
}

/** Header: active workgroup switcher, who is signed in, change password, sign out. */
export function UserMenu() {
  const { user, logout, switchWorkgroup } = useAuth();
  const [pwOpen, setPwOpen] = useState(false);
  if (!user) return null;
  return (
    <div className="flex items-center gap-2">
      <Select value={activeWorkgroupId() || ""} onValueChange={switchWorkgroup}>
        <SelectTrigger className="h-7 text-xs w-[180px]" data-testid="workgroup-switcher">
          <Users className="w-3.5 h-3.5 mr-1 text-cyan-400" /><SelectValue placeholder="Workgroup" />
        </SelectTrigger>
        <SelectContent>
          {user.workgroups.map((w) => <SelectItem key={w.id} value={w.id} data-testid={`workgroup-option-${w.id}`}>{w.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <button type="button" onClick={() => setPwOpen(true)} className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1" title="Change password" data-testid="user-menu-name">
        <UserCircle2 className="w-4 h-4" /> {user.name} <span className="opacity-60">({user.role})</span>
      </button>
      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={logout} title="Sign out" data-testid="logout-btn"><LogOut className="w-4 h-4" /></Button>
      <PasswordDialog open={pwOpen} setOpen={setPwOpen} />
    </div>
  );
}
